module.exports = __webpack_public_path__ + "static/media/introduce_p6.d33b2b05.png";